const serviceCognitoV5 = [
  /* 09-01-2023 */
  '/airports',
];

export default serviceCognitoV5;
// nuevos servicios que pasan por el token de cognito y canal v5